import { memo } from "react";

import TikTok from "../../../../../public/assets/icon/sns/tiktok.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const TikTokIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: TikTok });
	return <Icon />;
};

export default memo(TikTokIcon);
